import React,{useState,useEffect} from "react";
import { useRecoilState } from 'recoil';
import { useBedData } from '../../context/BedDataContext';
import { selectBedInfoState } from '../../plugins/recoil';
import Patient_16 from '../Patient_16';

function Index({onClose, handleTrend,handleAlarmReview,handleBedSetting,handleMeasurements,handleStandByConfirm, handlePrint}) {
    const { getSerialData, version } = useBedData()
    const [selectBedInfo, ] = useRecoilState(selectBedInfoState)    

    return (
        <div className="wrapper relative w-full h-full bg-black font-normal border-t border-white">
            <div className="bg-[#1F1F1F] w-full h-full">               
                <div className="h-full flex justify-between bg-black ">         
                    <Patient_16
                        bedInfo={selectBedInfo} 
                        bedData={getSerialData(selectBedInfo.serial)}
                        key={`patient-item-${0}`}
                        oneBed={true}
                        viewType={1}
                        patientCnt={1}
                        patientIdx={1}
                        clientHeight={100}
                        updateHeight={null}
                        heightChangeValue={null}
                        wardStatusChangeFlag={null}  
                        handleClose={()=> onClose()}   
                        handleTrend={handleTrend}
                        handleAlarmReview={handleAlarmReview}
                        handleBedSetting={handleBedSetting}
                        handleStandByConfirm={handleStandByConfirm}
                        handleMeasurements={handleMeasurements}
                        handlePrint={handlePrint}
                    />
                </div>
            </div>
        </div>
    );
}

export default Index;
